import { Heading, Paragraph } from '@zillow/constellation';
import React from 'react';

import FAQ from '../../../packages/zrs-cms/src/components/FAQ/FAQ';

import { FAQ_DATA } from './ZestimateFAQ.data';

// Re-export types for convenience
export type { FAQItem } from './ZestimateFAQ.types';

/**
 * ZestimateFAQ component displays frequently asked questions about Zillow's Zestimate.
 *
 * @component
 * @example
 * ```tsx
 * <ZestimateFAQ />
 * ```
 */
export function ZestimateFAQ(): JSX.Element {
    return (
        <FAQ defaultExpanded={[0]}>
            {FAQ_DATA.map((faq, index) => {
                const itemId = `zestimate-faq-item-${index}`;
                const headerId = `zestimate-faq-header-${index}`;
                const panelId = `zestimate-faq-panel-${index}`;

                return (
                    <FAQ.Item key={index} id={itemId}>
                        <FAQ.Header id={headerId} aria-controls={panelId}>
                            <Heading level="3" fontType="bodyHeading">
                                {faq.question}
                            </Heading>
                        </FAQ.Header>
                        <FAQ.Panel id={panelId} aria-labelledby={headerId}>
                            <Paragraph
                                dangerouslySetInnerHTML={{
                                    __html: faq.answer,
                                }}
                            />
                        </FAQ.Panel>
                    </FAQ.Item>
                );
            })}
        </FAQ>
    );
}
